<rappider-modal title="Edit Card Config"
                [(visible)]="isEditModalVisible"
                okText="Save"
                cancelText="Cancel"
                [fullScreen]="true"
                [autoClose]="modalAutoClose"
                [bodyStyle]="{ padding: '0.5rem 2.5rem 0rem 1.5rem' }"
                (okClick)="onCardConfigSave()"
                (cancelClick)="onCancel()"
                (afterModalOpen)="onCardModalAfterOpen()">
  <div class="container-fluid content-area card-builder-container"
       style="height: 100%;">

    <as-split direction="horizontal"
              [gutterSize]="10">
      <as-split-area [size]="50"
                     [minSize]="30"
                     [maxSize]="70">
        <div class="section-container">
          <div class="section-header">
            <div class="card-builder-header">
              <h6>Card Preview</h6>
            </div>
            <hr>
          </div>
          <div class="section-content card-preview-content">
            <div class="card-preview-wrapper">
              <rappider-card-ccs *ngIf="cardPreviewConfig"
                                  [title]="cardPreviewConfig.title"
                                  [subtitles]="cardPreviewConfig.subtitles"
                                  [description]="cardPreviewConfig.description"
                                  [iconConfig]="cardPreviewConfig.iconConfig"
                                  [iconName]="cardPreviewConfig.iconName"
                                  [secondActionButton]="cardPreviewConfig.editButton"
                                  [thirdActionButton]="cardPreviewConfig.deleteButton">
              </rappider-card-ccs>
              <nz-empty *ngIf="!cardPreviewConfig"
                        nzNotFoundImage="simple"
                        nzNotFoundContent="No preview data available. Add some data to see the card preview.">
              </nz-empty>
            </div>

            <!-- Validation Alert -->
            <div class="card-builder-validation-alert">
              <rappider-alert *ngIf="validationAlertVisible"
                              [type]="validationAlertConfig.type"
                              [title]="validationAlertConfig.title"
                              [description]="validationAlertConfig.description"
                              [closeable]="validationAlertConfig.closeable"
                              [showIcon]="validationAlertConfig.showIcon"
                              class="card-validation-alert"></rappider-alert>
            </div>

          </div>
        </div>
      </as-split-area>
      <as-split-area [size]="50"
                     [minSize]="30"
                     [maxSize]="70">
        <div class="section-container">
          <div class="section-content settings-content">
            <rappider-card-builder-settings [(ngModel)]="tempValue"
                                            [entityFields]="entityFields"
                                            [apiPath]="apiPath"
                                            (ngModelChange)="onItemsChange()"
                                            (editJsonData)="openJsonEditorModal()"></rappider-card-builder-settings>
          </div>
        </div>
      </as-split-area>
    </as-split>
  </div>
</rappider-modal>

<rappider-button text="Edit Card Data"
                 (click)="openEditModal()"></rappider-button>

<rappider-json-editor-modal [data]="tempValue"
                            [title]="'Edit Card Data'"
                            [visible]="isJsonEditorModalVisible"
                            (visibleChange)="onJsonEditorVisibleChange($event)"
                            (dataChange)="onDataChange($event)"></rappider-json-editor-modal>

